<div class="footer">
  <p class="copyright">
    © 2021-{{ year }} CoinDepo.
    <span class="white-space-nowrap">{{
      'footer.rights-reserved' | translate
      }}</span>
  </p>
  <ul class="footer-nav">
    <li>
      <a [href]="'footer.terms&conditions-href' | translate" target="_blank">{{
        'footer.terms&conditions' | translate
        }}</a>
    </li>
    <li>
      <a [href]="'footer.privacy-policy-href' | translate" target="_blank">{{
        'footer.privacy-policy' | translate
        }}</a>
    </li>
    <li>
      <a [href]="'footer.help-center-href' | translate" target="_blank">{{
        'footer.help-center' | translate
        }}</a>
    </li>
    <li dropdown [dropup]="true" class="position-relative" *ngIf="isDev || isStage">
      <a
        href
        dropdownToggle
        aria-controls="source-translate-link-dropdown"
        id="source-translate-link"
        (click)="(false)"
      >{{'footer.source-language' | translate}}: {{source}}</a
      >
      <ng-container>
        <ul
          id="source-translate-link-dropdown"
          *dropdownMenu
          class="dropdown-menu source-lang"
          role="menu"
          aria-labelledby="basic-link"
        >
          <li role="menuitem" (click)="changeSource('coindepo')">
            <a class="cursor-pointer">coindepo</a>
          </li>
          <li role="menuitem" (click)="changeSource('local')">
            <a class="cursor-pointer">local</a>
          </li>
        </ul>
      </ng-container>
    </li>
    <li dropdown [dropup]="true" class="position-relative">
      <a
        href
        dropdownToggle
        aria-controls="basic-link-dropdown"
        id="i18n-link"
        (click)="(false)"
      >{{ 'footer.language' | translate }}</a
      >

      <div
        id="i18n-link-dropdown"
        class="dropdown-menu"
        *dropdownMenu
        role="menu"
        aria-labelledby="basic-link"
      >
        <ul
        >
          <li role="menuitem" class="media-body" (click)="changeLang('en')" >
            <a class="cursor-pointer" [class.active]="(currentLang$ | async) === 'en'">English</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('de')" *ngIf="!isProd" >
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'de'">Deutsch</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('es')" *ngIf="!isProd" >
            <a class="cursor-pointer" [class.active]="(currentLang$ | async) === 'es'">Español (International)</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('es-419')" *ngIf="!isProd">
            <a class="cursor-pointer" [class.active]="(currentLang$ | async) === 'es-419'">Español (Latinoamérica)</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('fr')" *ngIf="!isProd" >
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'fr'">Français</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('it')" *ngIf="!isProd" >
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'it'">Italiano</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('pl')" *ngIf="!isProd" >
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'pl'">Polski</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('pt')" *ngIf="!isProd">
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'pt'">Português</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('ru')" *ngIf="!isProd" >
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'ru'">Русский</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('vi')" *ngIf="!isProd" >
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'vi'">Tiếng Việt</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('tr')" *ngIf="!isProd">
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'tr'">Türkçe</a>
          </li>
          <li role="menuitem" class="media-body" (click)="changeLang('uk')" *ngIf="!isProd">
            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'uk'">Українська</a>
          </li>
          <li role="menuitem" class="media-body" *ngIf="!isProd" (click)="changeLang('only-key')" >
            <a class="cursor-pointer" [class.active]="(currentLang$ | async) === 'only-key'">Тільки ключі</a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
